"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _PointLocator = _interopRequireDefault(require("../../algorithm/PointLocator"));

var _Location = _interopRequireDefault(require("../../geom/Location"));

var _TreeSet = _interopRequireDefault(require("../../../../../java/util/TreeSet"));

var _GeometryCombiner = _interopRequireDefault(require("../../geom/util/GeometryCombiner"));

var _CoordinateArrays = _interopRequireDefault(require("../../geom/CoordinateArrays"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PointGeometryUnion =
/*#__PURE__*/
function () {
  function PointGeometryUnion() {
    _classCallCheck(this, PointGeometryUnion);

    PointGeometryUnion.constructor_.apply(this, arguments);
  }

  _createClass(PointGeometryUnion, [{
    key: "union",
    value: function union() {
      var locater = new _PointLocator.default();
      var exteriorCoords = new _TreeSet.default();

      for (var i = 0; i < this._pointGeom.getNumGeometries(); i++) {
        var point = this._pointGeom.getGeometryN(i);

        var coord = point.getCoordinate();
        var loc = locater.locate(coord, this._otherGeom);
        if (loc === _Location.default.EXTERIOR) exteriorCoords.add(coord);
      }

      if (exteriorCoords.size() === 0) return this._otherGeom;
      var ptComp = null;

      var coords = _CoordinateArrays.default.toCoordinateArray(exteriorCoords);

      if (coords.length === 1) {
        ptComp = this._geomFact.createPoint(coords[0]);
      } else {
        ptComp = this._geomFact.createMultiPointFromCoords(coords);
      }

      return _GeometryCombiner.default.combine(ptComp, this._otherGeom);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return PointGeometryUnion;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "union",
    value: function union(pointGeom, otherGeom) {
      var unioner = new PointGeometryUnion(pointGeom, otherGeom);
      return unioner.union();
    }
  }]);

  return PointGeometryUnion;
}();

exports.default = PointGeometryUnion;

PointGeometryUnion.constructor_ = function () {
  this._pointGeom = null;
  this._otherGeom = null;
  this._geomFact = null;
  var pointGeom = arguments[0],
      otherGeom = arguments[1];
  this._pointGeom = pointGeom;
  this._otherGeom = otherGeom;
  this._geomFact = otherGeom.getFactory();
};